import { render } from "./CmsStoryphones.vue?vue&type=template&id=21439903&lang=html"
import script from "./CmsStoryphones.vue?vue&type=script&lang=js"
export * from "./CmsStoryphones.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__